<template>
  <div v-if="historyRow">
    <el-collapse v-model="activeName" accordion>
      <el-collapse-item
        :name="index+1" >
        <template slot="title"
                  data-test="history--time">
          <i class="el-icon-date" style="padding-right: 10px"></i>
          {{historyRow.time | concatenateDateAndTime}}
        </template>
        <div class="historyRow">
          <el-card class="box-card history--product">
            <div slot="header" class="clearfix">
              <i class="el-icon-box" style="padding-right: 10px"></i>
              <span data-test=history--title>{{$t('history.cardTitle')}} </span>
              <span class="history--user"> {{ historyRow.user }}</span>
              <el-tag
                :key="historyRow.id"
                type="success"
                effect="dark"
                size="big"
                class="order-number">
                commande n°{{ historyRow.id }}
              </el-tag>
              <el-tag data-test=history--supplier
                      :style="'float: right; padding: 1px 5px;' +
                       ' background-color: '
                       + getSupplierBgColor(historyRow.supplier)">
                {{historyRow.supplier}}
              </el-tag>
            </div>
            <el-row v-for="product in historyRow.cartOrder"
                    v-bind:key="product.id">
              <div class="historyRow--cartOrder">
                <span class="historyRow--cartOrder--name">{{product.name}}</span>
                <span class="historyRow--cartOrder--quantity">x{{product.quantity}}</span>
              </div>
              <el-divider></el-divider>
            </el-row>
          </el-card>
          <el-timeline :reverse="false">
            <el-timeline-item
              v-for="(status, index) in historyRow.status"
              :key="index"
              :timestamp="status.ts | concatenateDateAndTime">
              {{status.event}}
            </el-timeline-item>
          </el-timeline>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
  import '@/filters/date.filter';
  import { cssUtils } from '../../../utils/utils';

  import HistoryService from '../../../services/server/history-service/HistoryService';

  export default {
    props: {
      historyRow: {},
      index: Number,
    },
    data() {
      return {
        status: '',
        activeName: 1,
      };
    },
    computed: {
      historyStatus() {
        if (this.historyRow && this.historyRow.length) {
          return HistoryService.lastHistoryEvent(this.historyRow);
        }
        return '';
      },

      historyId() {
        if (this.historyRow && this.historyRow.length) {
          return `n°${this.historyRow.id}`;
        }
        return '';
      },
    },
    methods: {
      getSupplierBgColor(supplier) {
        return cssUtils.supplierBackgroundColor(supplier);
      },
    },
  };

</script>

<style lang="stylus">
  .historyRow
    display flex
    flex-direction row
    justify-content flex-start

  .order-number {
    margin-left 20px
  }

  .history--user
    color brown

  .history--product
    margin 10px
    background-color white
    width 50%

  .historyRow--cartOrder
    display flex
    flex-direction row

  .historyRow--cartOrder--name
    display flex
    flex-grow 2

  @media screen and (max-width: 600px)
    .history--product
      width 100%
</style>
